import {Style} from "./styled"

const MainContent = () =>{

return <div>
    <Style>

    </Style>
</div>

}
export {MainContent}